import { createAction } from '@reduxjs/toolkit';

const clearRejected = createAction<string>('apiRejected/clear');

export const apiRejectedActions = {
  clearRejected,
};
